"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPTIONS = void 0;
var tslib_1 = require("tslib");
var ajv_1 = tslib_1.__importDefault(require("ajv"));
var ajv_errors_1 = tslib_1.__importDefault(require("ajv-errors"));
var luxon_1 = require("luxon");
var expression_1 = require("@catalytic/expression");
var pushbot_expression_1 = require("@catalytic/pushbot-expression");
var uri_1 = require("@catalytic/uri");
var isEmail_1 = tslib_1.__importDefault(require("validator/lib/isEmail"));
var isUUID_1 = tslib_1.__importDefault(require("validator/lib/isUUID"));
var teamname_1 = require("./teamname");
var timezone_1 = require("./timezone");
var type_1 = require("./type");
var username_1 = require("./username");
var expression = expression_1.create();
var passthrough = function () { return true; };
exports.DEFAULT_OPTIONS = {
    meta: true,
    nullable: true,
    schemaId: 'auto',
    validateSchema: true
};
function createJSONSchemaValidator(options) {
    if (options === void 0) { options = {}; }
    var _a = options.ajvOptions, ajvOptions = _a === void 0 ? exports.DEFAULT_OPTIONS : _a, _b = options.assertReference, assertReference = _b === void 0 ? passthrough : _b;
    var ajv = new ajv_1.default(tslib_1.__assign(tslib_1.__assign({}, ajvOptions), { allErrors: true, jsonPointers: true }));
    ajv.addFormat('binary', { type: 'string', validate: function () { return true; } });
    ajv.addFormat('code', { type: 'string', validate: function () { return true; } });
    ajv.addFormat('code:css', { type: 'string', validate: function () { return true; } });
    ajv.addFormat('code:html', { type: 'string', validate: function () { return true; } });
    ajv.addFormat('code:javascript', { type: 'string', validate: function () { return true; } });
    ajv.addFormat('code:python', { type: 'string', validate: function () { return true; } });
    ajv.addFormat('condition', { type: 'string', validate: function () { return true; } });
    ajv.addFormat('duration', function (value) {
        try {
            var duration = luxon_1.Duration.fromISO(value);
            return duration.isValid;
        }
        catch (e) {
            return false;
        }
    });
    ajv.addFormat('timezone', timezone_1.isTimezone);
    ajv.addFormat('expression', function (value) {
        try {
            expression.compile(value);
            return true;
        }
        catch (e) {
            return false;
        }
    });
    ajv.addFormat('json', function (value) {
        try {
            JSON.parse(value);
            return true;
        }
        catch (e) {
            return false;
        }
    });
    ajv.addFormat('password', function () { return true; });
    ajv.addFormat('ref', function (value) {
        return uri_1.isURI(value) ||
            isUUID_1.default(value) ||
            isEmail_1.default(value) ||
            username_1.isUsername(value) ||
            teamname_1.isTeamname(value);
    });
    ajv.addKeyword('conditionalDependencies', {
        inline: function (_it, _keyword, schema) {
            pushbot_expression_1.parse(schema);
            return schema;
        },
        metaSchema: {
            type: 'string'
        }
    });
    ajv.addKeyword('expression', {
        validate: function (schema, data, _parentSchema, _path, _parentData, _parentProperty, rootData) { return expression.evaluate(schema, { this: data, fields: rootData }); },
        metaSchema: {
            format: 'expression',
            type: 'string'
        }
    });
    ajv.addKeyword('displayOnly', {
        metaSchema: {
            type: 'boolean'
        }
    });
    ajv.addKeyword('legacyFormat', {
        metaSchema: {
            type: 'string'
        }
    });
    ajv.addKeyword('minHeight', {
        metaSchema: {
            minimum: 1,
            type: 'number'
        }
    });
    ajv.addKeyword('minWidth', {
        metaSchema: {
            minimum: 1,
            type: 'number'
        }
    });
    ajv.addKeyword('maxHeight', {
        metaSchema: {
            minimum: 1,
            type: 'number'
        }
    });
    ajv.addKeyword('maxWidth', {
        metaSchema: {
            minimum: 1,
            type: 'number'
        }
    });
    ajv.addKeyword('refType', {
        validate: function (type, id) {
            if (!assertReference({ id: id, type: type })) {
                throw new Error("Unable to resolve reference " + type + " " + id);
            }
            return true;
        },
        metaSchema: {
            enum: Object.values(type_1.JSONRefType),
            type: 'string'
        }
    });
    ajv_errors_1.default(ajv, { keepErrors: true });
    return ajv;
}
exports.default = createJSONSchemaValidator;
//# sourceMappingURL=createJSONSchemaValidator.js.map